<template>
  <the-header></the-header>
  <main>
    <the-carousel></the-carousel>
    <etouka-section></etouka-section>
    <process-section></process-section>
    <rakuten-section></rakuten-section>
    <cta-section></cta-section>
  </main>

  <footer>
    <the-footer></the-footer>
  </footer>
</template>

<script>
import TheHeader from "../components/common/TheHeader.vue";
import TheCarousel from "../components/main/TheCarousel.vue";
import EtoukaSection from "../components/main/EtoukaSection.vue";
import ProcessSection from "../components/main/ProcessSection.vue";
import RakutenSection from "../components/main/rakuten/RakutenSection.vue";
import CtaSection from "../components/main/CTASection.vue";
import TheFooter from "../components/common/TheFooter.vue";

export default {
  components: {
    TheHeader,
    TheCarousel,
    EtoukaSection,
    ProcessSection,
    RakutenSection,
    CtaSection,
    TheFooter,
  },
};
</script>

<style scoped>
/* .container {
  padding: 0 16rem;
} */
</style>